import { createStyles, rem } from '@mantine/core'

type StylesParams = {
  type?: 'button' | 'radio'
}

export default createStyles((theme, { type }: StylesParams) => {
  const isMarryBaby = theme.other.template === 'mb'
  return {
    root: {},
    wrapper: {
      gap: rem(8),
      ...(type === 'radio' && {
        justifyContent: 'flex-end',
        gap: rem(24),
      }),
    },
    groupErr: {
      fontSize: rem(14),
    },
    itemRoot: {
      ...(type === 'button'
        ? {
            flexGrow: 1,
            width: '50%',
            '&[data-checked="true"]': {
              '.mantine-Radio-label': {
                borderColor: theme.fn.primaryColor(),
              },
            },
          }
        : type === 'radio'
        ? { padding: `${rem(10)} 0`, margin: 0 }
        : {}),
    },
    itemLabelWrapper: {
      padding: 0,
      width: '100%',
    },
    itemLabel: {
      whiteSpace: 'nowrap',
      ...(type === 'button'
        ? {
            position: 'relative',
            padding: `${rem(6)} ${rem(16)}`,
            border: `1px solid ${
              isMarryBaby ? '#EAEAEC' : theme.colors.gray[2]
            }`,
            borderRadius: rem(isMarryBaby ? 16 : 4),
            cursor: 'pointer',
            '&[data-disabled="true"]': {
              background: theme.colors.gray[1],
              color: `${theme.colors.gray[4]} !important`,
              img: {
                opacity: 0.5,
              },
            },
            img: {
              height: rem(26),
            },
          }
        : type === 'radio'
        ? { fontSize: rem(14) }
        : {}),
    },
    itemInner: {
      ...(type === 'button' && {
        display: 'none',
      }),
      ...(type === 'radio' && {
        alignSelf: 'center',
      }),
    },
    itemBody: {
      ...(type === 'radio' && {
        alignItems: 'center',
      }),
    },
  }
})
